import {Button, Dropdown, DropdownItem} from 'platform/components';

import i18n from '@dms/i18n';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

export interface ColumnVisibilityItem {
  key: string;
  label: string;
  isVisible: boolean;
}

interface PayPerUseColumnVisibilityDropdownProps extends RequiredTestIdProps {
  items: ColumnVisibilityItem[];
  onToggle: (key: string) => void;
}

export function PayPerUseColumnVisibilityDropdown(props: PayPerUseColumnVisibilityDropdownProps) {
  return (
    <Dropdown
      closeOnSelect={false}
      data-testid={suffixTestId('columns', props)}
      dropdownControl={
        <Button
          variant="secondary"
          leftIcon="action/view_week"
          title={i18n.t('page.payPerUseMetrics.leaderboard.columns')}
          data-testid={suffixTestId('columns-trigger', props)}
        />
      }
    >
      {props.items.map((item) => (
        <DropdownItem
          key={item.key}
          label={item.label}
          leftIcon={item.isVisible ? 'navigation/check' : undefined}
          closeOnClick={false}
          onClick={() => props.onToggle(item.key)}
          data-testid={suffixTestId(`columns-item-${item.key}`, props)}
        />
      ))}
    </Dropdown>
  );
}
